import React, { FunctionComponent } from 'react';
import { TitleLinkModel } from '../../models/navigationItem.model';
import RoutableSitecoreLink from '../../../@shared/routableSitecoreLink';

const TitleLink: FunctionComponent<{ model: TitleLinkModel; onClick?: () => void }> = ({ model, onClick }) => {
  return <RoutableSitecoreLink field={model.link} className="navigation-link navigation-link--title" onClick={onClick} />;
};

export default TitleLink;
